import React from 'react';
import { Modal } from './modal';
import { PaymentsMethods } from './payments-methods';
import { useIsBanned } from './shared/hooks/use-is-banned';
import './shared/payments.css';

export const Payments= (props) => {
  const isUserIsBanned = useIsBanned()

  if (isUserIsBanned) {
    return null;
  }

  if (props.type === 'modal') {
    return <Modal {...props} />
  }

  if (props.type === 'static') {
    return <PaymentsMethods {...props} />
  }

  return null
};